module.exports = __webpack_public_path__ + "img/2-2-IMG_3001.f5d388b5.png";